// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-tabs-container {
    margin-bottom: 1rem;
}

.product-tabs {
    display: flex;
    border-bottom: 1px solid #eee;
    gap: 0;
    align-items: center;
}

.tab-button {
    padding: 12px 20px;
    background: none;
    border: none;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    /*font-size: 14px;*/
    /*font-weight: 500;*/
    color: #666;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.tab-button:hover {
    color: #495057;
    background-color: #f8f9fa;
}

.tab-button.active {
    color: #316C29;
    border-bottom-color: #316C29;
    background-color: #fff;
}

.search-toggle-button {
    margin-left: 0;
    padding: 12px 20px;
    background: none;
    border: none;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    color: #666;
    transition: all 0.2s ease;
}

.refresh-button {
    margin-left: auto;
    padding: 12px 20px;
    background: none;
    border: none;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    color: #666;
    transition: all 0.2s ease;
}

.refresh-button:hover:not(:disabled) {
    color: #316C29;
    background-color: #f8f9fa;
}

.refresh-button:disabled {
    cursor: default;
    opacity: 0.6;
}

.search-toggle-button:hover {
    color: #316C29;
    background-color: #f8f9fa;
}

.product-search-field {
    padding: 1rem 0;
    border-bottom: 1px solid #eee;
}

.product-search-field input {
    width: 100%;
    padding: 10px 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
}

.product-search-field input:focus {
    outline: none;
    border-color: #316C29;
    box-shadow: 0 0 0 3px rgba(49, 108, 41, 0.1);
}
[data-theme="dark"] .product-tabs { border-bottom-color: #2c3a33; }
[data-theme="dark"] .tab-button,
[data-theme="dark"] .search-toggle-button,
[data-theme="dark"] .refresh-button { color: #9fb0a6; }
[data-theme="dark"] .tab-button:hover,
[data-theme="dark"] .refresh-button:hover:not(:disabled),
[data-theme="dark"] .search-toggle-button:hover { color: #cfe3d6; background-color: #222f28; }
[data-theme="dark"] .tab-button.active { background-color: #1c2620; }
[data-theme="dark"] .product-search-field { border-bottom-color: #2c3a33; }
[data-theme="dark"] .product-search-field input { border-color: #3a463e; background: #1c2620; color: #e3ece6; }

@media (max-width: 768px) {
    .product-tabs {
        flex-wrap: wrap;
        gap: 5px;
        border-bottom: 1px solid #e9ecef;
    }
    
    .tab-button {
        padding: 10px 16px;
        font-size: 13px;
        flex: 1;
        min-width: 0;
        border-radius: 4px 4px 0 0;
    }
    
    .tab-button.active {
        border-bottom: 2px solid #316C29;
    }
    
    .search-toggle-button {
        padding: 10px 16px;
        margin-left: 0;
        flex: 0 0 auto;
    }

    .refresh-button {
        padding: 10px 16px;
        margin-left: auto;
        flex: 0 0 auto;
    }
}

@media (max-width: 480px) {
    .tab-button {
        padding: 8px 12px;
        font-size: 12px;
    }
    
    .search-toggle-button {
        padding: 8px 12px;
    }

    .refresh-button {
        padding: 8px 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Seller/ProductTabs.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;AACA,oCAAoC,4BAA4B,EAAE;AAClE;;sCAEsC,cAAc,EAAE;AACtD;;kDAEkD,cAAc,EAAE,yBAAyB,EAAE;AAC7F,yCAAyC,yBAAyB,EAAE;AACpE,4CAA4C,4BAA4B,EAAE;AAC1E,kDAAkD,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAE9G;IACI;QACI,eAAe;QACf,QAAQ;QACR,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,OAAO;QACP,YAAY;QACZ,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".product-tabs-container {\n    margin-bottom: 1rem;\n}\n\n.product-tabs {\n    display: flex;\n    border-bottom: 1px solid #eee;\n    gap: 0;\n    align-items: center;\n}\n\n.tab-button {\n    padding: 12px 20px;\n    background: none;\n    border: none;\n    border-bottom: 3px solid transparent;\n    cursor: pointer;\n    /*font-size: 14px;*/\n    /*font-weight: 500;*/\n    color: #666;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.tab-button:hover {\n    color: #495057;\n    background-color: #f8f9fa;\n}\n\n.tab-button.active {\n    color: #316C29;\n    border-bottom-color: #316C29;\n    background-color: #fff;\n}\n\n.search-toggle-button {\n    margin-left: 0;\n    padding: 12px 20px;\n    background: none;\n    border: none;\n    border-bottom: 3px solid transparent;\n    cursor: pointer;\n    color: #666;\n    transition: all 0.2s ease;\n}\n\n.refresh-button {\n    margin-left: auto;\n    padding: 12px 20px;\n    background: none;\n    border: none;\n    border-bottom: 3px solid transparent;\n    cursor: pointer;\n    color: #666;\n    transition: all 0.2s ease;\n}\n\n.refresh-button:hover:not(:disabled) {\n    color: #316C29;\n    background-color: #f8f9fa;\n}\n\n.refresh-button:disabled {\n    cursor: default;\n    opacity: 0.6;\n}\n\n.search-toggle-button:hover {\n    color: #316C29;\n    background-color: #f8f9fa;\n}\n\n.product-search-field {\n    padding: 1rem 0;\n    border-bottom: 1px solid #eee;\n}\n\n.product-search-field input {\n    width: 100%;\n    padding: 10px 15px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.product-search-field input:focus {\n    outline: none;\n    border-color: #316C29;\n    box-shadow: 0 0 0 3px rgba(49, 108, 41, 0.1);\n}\n[data-theme=\"dark\"] .product-tabs { border-bottom-color: #2c3a33; }\n[data-theme=\"dark\"] .tab-button,\n[data-theme=\"dark\"] .search-toggle-button,\n[data-theme=\"dark\"] .refresh-button { color: #9fb0a6; }\n[data-theme=\"dark\"] .tab-button:hover,\n[data-theme=\"dark\"] .refresh-button:hover:not(:disabled),\n[data-theme=\"dark\"] .search-toggle-button:hover { color: #cfe3d6; background-color: #222f28; }\n[data-theme=\"dark\"] .tab-button.active { background-color: #1c2620; }\n[data-theme=\"dark\"] .product-search-field { border-bottom-color: #2c3a33; }\n[data-theme=\"dark\"] .product-search-field input { border-color: #3a463e; background: #1c2620; color: #e3ece6; }\n\n@media (max-width: 768px) {\n    .product-tabs {\n        flex-wrap: wrap;\n        gap: 5px;\n        border-bottom: 1px solid #e9ecef;\n    }\n    \n    .tab-button {\n        padding: 10px 16px;\n        font-size: 13px;\n        flex: 1;\n        min-width: 0;\n        border-radius: 4px 4px 0 0;\n    }\n    \n    .tab-button.active {\n        border-bottom: 2px solid #316C29;\n    }\n    \n    .search-toggle-button {\n        padding: 10px 16px;\n        margin-left: 0;\n        flex: 0 0 auto;\n    }\n\n    .refresh-button {\n        padding: 10px 16px;\n        margin-left: auto;\n        flex: 0 0 auto;\n    }\n}\n\n@media (max-width: 480px) {\n    .tab-button {\n        padding: 8px 12px;\n        font-size: 12px;\n    }\n    \n    .search-toggle-button {\n        padding: 8px 12px;\n    }\n\n    .refresh-button {\n        padding: 8px 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
